export default __webpack_public_path__ + "static/media/linked_in.0c83d135.svg";